import React, { useState, useEffect } from 'react';
import './App.css';

import AuthCheck from './components/AuthCheck'; // Компонент проверки авторизации
import MonitoringVisits from './components/VisitsMonitoring';

import { BrowserRouter as Router } from 'react-router-dom'; // Импортируем BrowserRouter


function App() {
  const [profiles, setProfiles] = useState([]);
  const [activeTab, setActiveTab] = useState("people");
  const [totalUnread, setTotalUnread] = useState(0);
  const [selectedProfile, setSelectedProfile] = useState(null); // Выбранный профиль
  const [isAnimating, setIsAnimating] = useState(false); // Управление анимацией
  const [activeScreen, setActiveScreen] = useState("profile"); // Экран по умолчанию

  const [loading, setLoading] = useState(false); // Состояние загрузки

  const [isAuthenticated, setIsAuthenticated] = useState(false); // Состояние авторизации


  const defaultAvatar = "images/dog.png";


  useEffect(() => {
    
    
    //localStorage.removeItem('session'); // Удаляем сессию
        
    const session = JSON.parse(localStorage.getItem('session'));
    
    if (session && session.userId && session.token) {
      setIsAuthenticated(true); // Если сессия существует, пользователь авторизован
    } else {
      setIsAuthenticated(false); // Если сессия не существует, пользователь не авторизован
    }
    
    
    setLoading(true);

    fetch('http://212.109.216.87/mytracker25_site/edited/head_list_of_profiles.php')
      .then(response => response.json())
      .then(data => {
        const parsedProfiles = data.profiles.map((name, index) => ({
          id: data.vkIds[index],
          name: name,
          firstname: data.profiles_firstname[index],
          avatar: data.photos[index] || defaultAvatar,
          status: data.lastSeen[index] === "Online" ? 'online' : 'offline',
          lastSeen: getLastSeenText(data.lastSeen[index]),
          
          profile_stats: data.stats[data.vkIds[index]] || { 
            friends: 0,
            followers: 0,
            groups: 0,
          },
          
          notifications: data.notifications[data.vkIds[index]] || { 
            new_friends: 0, 
            new_followers: 0, 
            new_groups: 0, 
            all_notifications: 0 
          }
        }));
        setProfiles(parsedProfiles);
        setTotalUnread(data.totalUnread);
        
       // setLoading(false);
        
        // Добавляем задержку перед отключением состояния загрузки
        setTimeout(() => {
          setLoading(false);
        }, 700); // Задержка в 500 миллисекунд
        
        
        
      })
      .catch(error => console.error('Ошибка при загрузке данных:', error));
     // setLoading(false);

        // Добавляем задержку перед отключением состояния загрузки
        setTimeout(() => {
          setLoading(false);
        }, 700); // Задержка в 500 миллисекунд
      
      
      
      
  }, []);


  
  const getLastSeenText = (_time) => {
  
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayUnix = Math.floor(today.getTime() / 1000);
    const yesterdayUnix = todayUnix - 86400;
    const oneYear = 31536000;
  
    const date = new Date(_time * 1000);
    const timeString = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    const fullDateString = date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
    const yearDateString = date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
  
    if (_time === "Online") {
      return "Online";
    } else if (_time === 0) {
      return "Этот аккаунт заблокирован";
    } else if (_time === 1) {
      return "Был(а) в сети недавно";
    } else if ((todayUnix - _time) > oneYear) {
      return `Заходил ${yearDateString}`;
    } else if ((_time - todayUnix) > 0) {
      return `Заходил сегодня, ${timeString}`;
    } else if ((_time - yesterdayUnix) > 0) {
      return `Заходил вчера, ${timeString}`;
    } else if (_time > 0) {
      return `Заходил ${fullDateString}`;
    }
  
    return "";
  };
  
  
  
  // Обработка нажатия на карточку профиля
  const handleProfileClick = (profile) => {
    window.scrollTo(0, 0);
    setSelectedProfile(profile);
  };

 // Обработка нажатия на кнопку "Назад" в VisitsMonitoring
  const handleBackClickFromMonitoring = () => {
    setActiveScreen("profile");
  };
  
  
  // Обработка нажатия на кнопку "Назад"
  const handleBackClick = () => {
    setActiveScreen("profile");
    setSelectedProfile(null);
  };
  
  // Обработка нажатия на кнопку "Мониторинг посещений"
  const handleMonitoringVisitsClick = () => {
      setActiveScreen("VisitsMonitoring");
  };
  

  return (
    
    
     
    <div className="App">
    <AuthCheck>


      {/* Отображаем top-bar только если профиль не выбран */}
      {activeScreen === "profile" && !selectedProfile && (
        <div className="top-bar">
          <div className="top-bar-inside">
            <div className="tabs">
              <button
                className={`tab-button ${activeTab === "people" ? "active" : ""}`}
                onClick={() => setActiveTab("people")}
              >
                Люди <span className="notification">{totalUnread}</span>
              </button>
              <button
                className={`tab-button ${activeTab === "photos" ? "active" : ""}`}
                onClick={() => setActiveTab("photos")}
              >
                Фотографии <span className="notification">2</span>
              </button>
              
              
            </div>
          </div>
        </div>
      )}
    
    
    
      {activeScreen === "profile" && selectedProfile && (
        
 <div className="top-bar-profile">
 
   <div className="top-bar-inside-profile">
   
     <button className="back-button" onClick={handleBackClick}>
     <img
       src="images/strelka_left_menu_bar.png"
       alt="Назад"
       className="back-button-image"
       />
     </button>
     
 
     <h2 className="profile-name-centered">{selectedProfile.firstname}</h2>
 
     <div className="button-group-right">
       <button className="button_podrobnee_right">П</button>
       <button className="button_delete_right">У</button>
     </div>
     
   </div>
   
 </div>

      )}
      
    
    {activeScreen === "profile" && (
      <header className="App-header">
      
        {/* Отображаем выбранный профиль */}
        {selectedProfile ? (
          
          <div className="profile-container">

          <div className="profile-detail">
            
    
          <div className="profile-info">
          
            <div className="profile-avatar-container">
              <div className="profile-avatar-padding">
                <img
                  src={selectedProfile.avatar}
                  alt={selectedProfile.name}
                  className="profile-avatar-large"
                />
                <p className={`profile-status-profile ${selectedProfile.status}`}></p>
              </div>
            </div>
            
            
            
          <div className="profile-name-status">
            <h3 className="profile-name-profilePage">{selectedProfile.name}</h3>
            <p className="profile-status-text-profilePage">
            {selectedProfile.lastSeen}
            </p>
          </div>
          
          
            
            </div> {/* <div className="profile-info">*/}
    
    
    
       <div className="profile-stats-container">
       <div className="profile-stats">
         <div className="stat-item">
           <h4>{selectedProfile.profile_stats.friends}</h4>
           <p>друзей</p>
           {/* Условно рендерим кружок с уведомлением только если сумма new_friends и old_friends больше 0 */}
           {(selectedProfile.notifications.new_friends + selectedProfile.notifications.old_friends) > 0 && (
             <div className="notification-badge">
               {selectedProfile.notifications.new_friends + selectedProfile.notifications.old_friends}
             </div>
           )}
         </div>              
         <div className="stat-item">
           <h4>{selectedProfile.profile_stats.followers}</h4>
           <p>подписчиков</p>
           {/* Условно рендерим кружок с уведомлением только если сумма new_followers и old_followers больше 0 */}
           {(selectedProfile.notifications.new_followers + selectedProfile.notifications.old_followers) > 0 && (
             <div className="notification-badge">
               {selectedProfile.notifications.new_followers + selectedProfile.notifications.old_followers}
             </div>
           )}
         </div>
         <div className="stat-item">
           <h4>{selectedProfile.profile_stats.groups}</h4>
           <p>групп</p>
           {/* Условно рендерим кружок с уведомлением только если сумма new_groups и old_groups больше 0 */}
           {(selectedProfile.notifications.new_groups + selectedProfile.notifications.old_groups) > 0 && (
             <div className="notification-badge">
               {selectedProfile.notifications.new_groups + selectedProfile.notifications.old_groups}
             </div>
           )}
         </div>
       </div>
          
            
            
            <div className="profile-stats">
              <div className="stat-item dimmed">
                <h4>0</h4>
                <p>фото</p>
              </div>
              <div className="stat-item dimmed">
                <h4>0</h4>
                <p>видео</p>
              </div>
              <div className="stat-item disabled">
                <h4>0</h4>
                <p>пусто</p>
              </div>
                
                
            </div>
            
            </div> {/* end  <div className="profile-stats">*/}
            
    
           <div className="profile-actions">
           <button
             className="profile-action-button"
             onClick={handleMonitoringVisitsClick}
           >
             Мониторинг посещений
           </button>
              <button className="profile-action-button">Мониторинг переписок</button>
              <button className="profile-action-button">Мониторинг информации</button>
            </div>
          </div>
          
          </div>
        ) : (
          <>
           {activeTab === "people" && (
           <div className="profile-grid">
             {loading
               ? Array.from({ length: 6 }).map((_, index) => (
                 <>
                   <div key={index} className="card_load_inGrid">
                   <div className="profile-load-container"> loading </div>
                   </div>
                   </>
                 ))
               : profiles.map((profile) => (
                   <div
                     key={profile.id}
                     className="profile-card"
                     onClick={() => handleProfileClick(profile)}
                   >
                     <img
                       src={profile.avatar}
                       alt={profile.name}
                       className="profile-avatar"
                       onError={(e) => (e.target.src = defaultAvatar)}
                     />
                     <div className="profile-name-container">
                       <div className={`profile-status ${profile.status}`}></div>
                       <p className="profile-name">{profile.name}</p>
                     </div>
                     <div className="profile-notifications">
                       {profile.notifications.all_notifications > 0
                         ? profile.notifications.all_notifications
                         : null}
                     </div>
                   </div>
                 ))}
              </div>
            )}
            {activeTab === "photos" && (
              <div className="photos-tab-content">
                <p>Данный раздел находится в разработке.</p>
                
                
                <div className="card">
                
                  <div className="card_load"></div>
                  <div className="card_load_extreme_title"></div>
                  <div className="card_load_extreme_descripion"></div>
                </div>
                
              </div>
               
            )}
          </>
        )}
      </header>
      )}
      
      
      {activeScreen === "VisitsMonitoring" && selectedProfile && (
        <MonitoringVisits profile={selectedProfile} onBack={handleBackClickFromMonitoring} />

      )}
      
      
      </AuthCheck>
    </div>
    
    
  );
}

export default App;
